import { InjectionToken } from '@angular/core';
import { FortressConfig } from '@psu-pennstateit-swe/apis/fortress';
import { SearchConfig } from '@psu-pennstateit-swe/apis/search';
import { CdnConfig } from '@psu-pennstateit-swe/utils/cdn';
import { AuthConfigWithDiscoveryDoc } from '@psu-pennstateit-swe/utils/security';

export interface FortressProperties {
  cdn: CdnConfig;
  environmentLabel?: string;
  featureFlags?: Record<string, boolean>;
  fortress: FortressConfig;
  oauth: AuthConfigWithDiscoveryDoc;
  production: boolean;
  searchService: SearchConfig;
}

export const APP_PROPERTIES = new InjectionToken<FortressProperties>('app.properties');
